import { TableColumn } from "features/common/components/Table/Table.types";

export const columns: TableColumn[] = [
  {
    id: "firstname",
    label: "Firstname",
  },
  {
    id: "lastname",
    label: "Lastname",
  },
  {
    id: "address",
    label: "Address",
  },
  {
    id: "number",
    label: "No.",
  },
  {
    id: "zipCode",
    label: "Plz",
  },
  {
    id: "residence",
    label: "City",
  },
];
